import { getStepsEmbedNavMode } from "@/hooks/use-steps-embed-nav-mode"
import { isOneSiteDemoEmbedPath } from "@/lib/one-site-demo"
import { isInstituteManagementDemoPath } from "@/lib/school-admin-nav"
import { isStudentExxatOneShellPath } from "@/lib/student-exxat-one-utility-bar"

/** Exxat One (schools) dashboard — STEPS demo iframe. */
export function isExxatOneSchoolsDemoDashboardPath(pathname: string): boolean {
  return pathname === "/one-schools/dashboard"
}

/** Program Management hub routes (STEPS iframe shell). */
export function isProgramManagementPath(pathname: string): boolean {
  if (pathname === "/programs" || pathname.startsWith("/programs/")) return true
  return /\/program-details(\/|$)/.test(pathname)
}

/** Course Management hub (STEPS iframe). Detail routes keep the product sidebar. */
export function isCourseManagementPath(pathname: string): boolean {
  return pathname === "/courses"
}

/** Student and Faculty Management hubs (STEPS iframes). */
export function isPeopleWorkspacePath(pathname: string): boolean {
  return pathname === "/people/students" || pathname === "/people/faculty"
}

/** Curriculum Mapping hub routes (STEPS iframe shell). */
export function isCurriculumMappingPath(pathname: string): boolean {
  return /\/curriculum-mapping(\/|$)/.test(pathname)
}

/** Hide Exxat primary sidebar when the demo iframe shows its own top tab bar. */
export function hidesPrimarySidebar(pathname: string): boolean {
  if (isOneSiteDemoEmbedPath(pathname)) return true
  if (isInstituteManagementDemoPath(pathname)) return true
  if (isStudentExxatOneShellPath(pathname)) return true
  // Course Management is an embedded demo. The host sidebar stays hidden;
  // the pane uses top tabs, which is the navigation demo default.
  if (isCourseManagementPath(pathname)) return true
  if (isPeopleWorkspacePath(pathname)) return true
  if (!isProgramManagementPath(pathname)) return false
  return getStepsEmbedNavMode() === "tabs"
}

/** No sidebar toggle when the primary sidebar is hidden for demo top tabs. */
export function hidesUtilityBarSidebarToggle(pathname: string): boolean {
  return hidesPrimarySidebar(pathname)
}
